import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useForgotPasswordMutation } from '../../app/services/auth';

import { Button, FormControl, TextField, Typography, Box, Stack } from '@mui/material';

import styles from './style.module.css';
import { Link } from 'react-router-dom';

function ResetPassword() {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const [forgotPassword] = useForgotPasswordMutation();
  const { t } = useTranslation();

  const handleEmailInput = (e) => {
    setEmail(e.target.value);
    setEmailError(false);
    setError('');
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!email.includes('@')) {
      setEmailError(true);
      return;
    }

    const formData = {
      email: email,
    };
    try {
      const response = await forgotPassword(formData);
      if (response.error) {
        setError(response.error.data.message);
      } else {
        setMessage(t('signIn.passwordRecoverySent'));
        setEmail('');
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.container_logo}>
        <Typography variant="h4">Wartungssoftware KMG</Typography>
      </div>
      <div className={styles.container_email}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <Typography variant="h4" fontWeight="bold" mb={2}>
            {t('signIn.forgotPassword')}
          </Typography>
          <Typography variant="body1" className={styles.subtitle}>
            {t('signIn.resetPasswordSubtitle')}
          </Typography>
          <Stack component="form" onSubmit={handleSubmit} sx={{ width: '100%' }}>
            <FormControl fullWidth variant="outlined" sx={{ mb: 1 }}>
              <TextField
                id="outlined-basic"
                label={t('signIn.emailAddress')}
                variant="outlined"
                fullWidth
                margin="normal"
                value={email}
                onChange={(e) => handleEmailInput(e)}
                error={emailError}
                helperText={emailError ? t('signIn.invalidEmail') : ' '}
                InputLabelProps={{ shrink: true }}
              />
            </FormControl>

            <Button
              fullWidth
              variant="contained"
              type="submit"
              color="primary"
              style={{ marginTop: '10px', height: '42px' }}
            >
              {t('signIn.submit')}
            </Button>
            
            {error && (
              <Typography color="error" style={{ marginTop: '10px', textAlign: 'center' }}>
                {error}
              </Typography>
            )}
            {message && (
              <Typography style={{ marginTop: '10px', textAlign: 'center', color: 'var(--text-primary)' }}>
                {message}
              </Typography>
            )}
          </Stack>
          <Link to="/sign-in" className={styles.link}>
            {t('signIn.backLogin')}
          </Link>
        </Box>
      </div>
    </div>
  );
}

export default ResetPassword;
